var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.647,
    height: 23.778,
    viewBox: "0 0 24.647 23.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_17029",
    width: 24.647,
    height: 23.778,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_12088",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_12087",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26090",
    d: "M4.04,1053.475l3.055,3.294a8.52,8.52,0,0,1,2.779-1.99l.437-.195a6.191,6.191,0,0,1-1.344-2.971,5.181,5.181,0,0,1-5.511-1.235,5.816,5.816,0,0,0-3.455,5.3,9.924,9.924,0,0,0,.042,2.1l4-4.308",
    transform: "translate(0 -1042.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26091",
    d: "M417.657,8.234a4.1,4.1,0,0,0,1.73-.381,6.205,6.205,0,0,1,2.277-4.676,4.115,4.115,0,1,0-4.007,5.056",
    transform: "translate(-410.496 -0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26092",
    d: "M860.908,1739.162a6.9,6.9,0,0,1-9.87,0,7.786,7.786,0,0,0-2.576,1.858L850.3,1743h-3.116c-.354,3.171.419,4.307,3.675,6.275a21.106,21.106,0,0,1,12.588.75,1.512,1.512,0,0,0,2.065-1.412v-2.391a7.748,7.748,0,0,0-4.6-7.06",
    transform: "translate(-840.865 -1726.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26093",
    d: "M1312.318,350.7a5.482,5.482,0,1,0-5.45-6.082,5.483,5.483,0,0,0,5.45,6.082",
    transform: "translate(-1297.209 -337.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26094",
    d: "M50.556,1621.719h2.076l-3.707-4-3.707,4h2.076c.553,5.441,2.3,6.986,7.58,7.867-3.984-2.346-4.921-3.736-4.318-7.867",
    transform: "translate(-44.885 -1605.807)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralOverviewIcon);
export default __webpack_public_path__ + "static/media/referral-overview-icon.672569bddbde6ea083148c057bb07d7f.svg";
export { ForwardRef as ReactComponent };